import styled from "styled-components"

export const Wrapper = styled.div`
  /* MODIFIERS */
  ${({ theme }) => theme.modifiers}
`
